export enum SettingPromotionOrderEnum {
  CREATED = 'CREATED',
  ASC = 'ASC',
  DESC = 'DESC',
  ENDED = 'ENDED',
}
